import PropTypes from 'prop-types';
import { useState } from 'react';
import FacetCheckbox from './facet_checkbox';
import ShowMoreButton from './show_more_button';

const { $ } = window;
const INITIAL_ITEMS_COUNT = 10;

const FacetCheckboxes = ({ isChildList, children, items, context, showMore }) => {
  const [expanded, setExpanded] = useState(isChildList || false);

  const initialItems = items.slice(0, INITIAL_ITEMS_COUNT);
  const remainingItems = items.slice(INITIAL_ITEMS_COUNT, items.length);
  const canShowMore = remainingItems.length > 0 && !expanded;

  const expand = () => {
    setExpanded(true);
  };
  const classNames = () => {
    const classes = ['lp-filter-list'];

    if (isChildList) {
      classes.push('children');
    }

    return classes.join(' ');
  };

  // Scrolls just the facet list (scroll inside the div) not the entire body.
  const handleMouseEnter = (e) => {
    if (isChildList) return;

    const { currentTarget, type, originalEvent } = e;

    if (currentTarget.offsetHeight >= currentTarget.scrollHeight) return;

    $('.lp-filter-list').bind('mousewheel DOMMouseScroll', function unnamed() {
      let scrollTo = null;
      if (type === 'mousewheel') {
        scrollTo = originalEvent.wheelDelta * -1;
      } else if (type === 'DOMMouseScroll') {
        scrollTo = 40 * originalEvent.detail;
      }
      if (scrollTo) {
        e.preventDefault();
        $(this).scrollTop(scrollTo + $(this).scrollTop());
      }
    });
  };

  // When the facet list is "moused-out" then the body can be scrolled.
  const handleMouseLeave = () => {
    if (isChildList) {
      return null;
    }
    return $('.lp-filter-list').unbind('mousewheel DOMMouseScroll');
  };

  const itemsComponents = (itemsToRender) => {
    let components;

    if (children) {
      components = children;
    } else {
      components = itemsToRender.map((item) => (
        <FacetCheckbox key={item.id} facet={item} context={context} showMore={showMore} />
      ));
    }

    return components;
  };

  return (
    <>
      <span>
        <ul
          className={classNames()}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {itemsComponents(initialItems)}
          <div
            className={`${
              expanded
                ? 'max-h-[9999px] overflow-hidden transition transition-[max-height] duration-700'
                : 'max-h-6'
            }`}
          >
            {expanded ? itemsComponents(remainingItems) : null}
          </div>
        </ul>
        {canShowMore ? (
          <ShowMoreButton count={remainingItems.length} onClickHandler={expand} />
        ) : null}
      </span>
    </>
  );
};

FacetCheckboxes.propTypes = {
  isChildList: PropTypes.bool,
  children: PropTypes.array,
  items: PropTypes.array,
  context: PropTypes.object,
  showMore: PropTypes.bool
};

export default FacetCheckboxes;
